import type { LeadStatusFilter } from 'app/features/leads/services/gym-finder/types';

export type LeadsPageState = 'zero-leads-profile-incomplete' | 'first-lead' | 'filtered-empty' | 'table';

type GetLeadsPageStateParams = {
  totalCount: number;
  filteredCount: number;
  profileComplete: boolean;
  search: string;
  status: LeadStatusFilter;
};

const hasActiveFilters = (search: string, status: LeadStatusFilter) => search.trim().length > 0 || status !== 'all';

export const getLeadsPageState = ({
  totalCount,
  filteredCount,
  profileComplete,
  search,
  status,
}: GetLeadsPageStateParams): LeadsPageState => {
  if (totalCount === 0 && !profileComplete) {
    return 'zero-leads-profile-incomplete';
  }

  if (totalCount === 1 && filteredCount === 1 && !hasActiveFilters(search, status)) {
    return 'first-lead';
  }

  if (totalCount > 0 && filteredCount === 0) {
    return 'filtered-empty';
  }

  return 'table';
};
